import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import ToastrService from '@/shared/services/ToastrService';
import messages from '@/modules/documents/documentMessages';
import { SpinnerIcon } from '@/shared/components/Icons';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { FormattedMessage } from 'react-intl';
import { SharepointFolderTree } from '@/modules/documents/modals/SharepointFolderTree';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import { SharepointFileSelector } from '@/modules/documents/modals/SharepointFileSelector';
import { SharepointSiteAutoComplete, } from '@/modules/documents/modals/SharepointSiteAutoComplete';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
const LinkFromSharepointModal = ({ show, intl, onSave, onClose, relationId, tags }) => {
    var _a, _b, _c;
    const [foldersLoading, setFoldersLoading] = useState(false);
    const [sitesLoading, setSitesLoading] = useState(true);
    const [selectedSite, setSelectedSite] = useState(null);
    const [drivesLoading, setDrivesLoading] = useState(false);
    const [drives, setDrives] = useState([]);
    const [selectedDriveId, setSelectedDriveId] = useState(null);
    const [selectedFolderId, setSelectedFolderId] = useState('/');
    const [selectedFileId, setSelectedFileId] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState(null);
    const selectedSiteId = (_a = selectedSite === null || selectedSite === void 0 ? void 0 : selectedSite.key) !== null && _a !== void 0 ? _a : null;
    useEffect(() => {
        setDrives([]);
        setSelectedDriveId(null);
        setSelectedFolderId('/');
        if (!selectedSiteId)
            return;
        setDrivesLoading(true);
        api.base
            .get(`${config.appUrls.documents}/api/sharepoint/sites/${selectedSiteId}/drives`)
            .then(x => {
            setDrives(!x.data ? [] : x.data);
        }, error => {
            handleHttpError(intl)(error);
        })
            .finally(() => {
            setDrivesLoading(false);
        });
    }, [selectedSiteId, intl]);
    const save = () => {
        let url = `${config.appUrls.documents}/api/documents/LinkToAdminPulse?driveId=${selectedDriveId}&folderId=${selectedFolderId}&fileId=${selectedFileId}&filename=${selectedFileName}`;
        if (tags) {
            url = `${url}&tags=${tags}`;
        }
        if (relationId) {
            url = `${url}&relationId=${relationId}`;
        }
        return api.base.post(url, {}).then(data => {
            ToastrService.changesSaved(intl);
            return onSave(data.data);
        }, error => {
            handleHttpError(intl)(error);
        });
    };
    const closeModal = () => {
        onClose();
    };
    if (!show)
        return null;
    const title = () => {
        if (!sitesLoading && !drivesLoading && !foldersLoading)
            return intl.formatMessage(messages.LinkFromSharepoint);
        return (_jsxs(_Fragment, { children: [intl.formatMessage(messages.LinkFromSharepoint), _jsx("span", Object.assign({ className: "margin5L" }, { children: _jsx(SpinnerIcon, {}) }))] }));
    };
    return (_jsx(OkCancelModal, Object.assign({ title: title(), show: show, onClose: closeModal, disabled: !selectedSiteId ||
            !selectedDriveId ||
            !selectedFolderId ||
            !selectedFileId ||
            !selectedFileName, onSave: save }, { children: _jsx("div", Object.assign({ className: "form-horizontal" }, { children: _jsx("div", { children: _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("label", Object.assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, Object.assign({}, messages.SharepointSite)) })), _jsx("div", Object.assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(SharepointSiteAutoComplete, { value: selectedSite, onChange: setSelectedSite, onLoadingChanged: setSitesLoading }) })), _jsx("label", Object.assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, Object.assign({}, messages.SharepointDrive)) })), _jsx("div", Object.assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(AutoComplete, { mode: "edit", disabled: !selectedSiteId || drivesLoading, items: drives.map(d => ({ key: d.id, label: d.name })), value: selectedDriveId
                                    ? {
                                        key: selectedDriveId,
                                        label: (_c = (_b = drives.find(d => d.id === selectedDriveId)) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '',
                                    }
                                    : null, onChange: item => { var _a; return setSelectedDriveId((_a = item === null || item === void 0 ? void 0 : item.key) !== null && _a !== void 0 ? _a : null); } }) })), _jsx("label", Object.assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, Object.assign({}, messages.Folder)) })), _jsx("div", Object.assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(SharepointFolderTree, { setLoading: setFoldersLoading, onSelectedFolderChanged: setSelectedFolderId, siteId: selectedSiteId, driveId: selectedDriveId }) })), _jsx("label", Object.assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, Object.assign({}, messages.File)) })), _jsx("div", Object.assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(SharepointFileSelector, { siteId: selectedSiteId, driveId: selectedDriveId, folderId: selectedFolderId, onFileSelected: (name, fileId) => {
                                    setSelectedFileName(name);
                                    setSelectedFileId(fileId);
                                }, selectedFileId: selectedFileId }) }))] })) }) })) })));
};
LinkFromSharepointModal.propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    relationId: PropTypes.string,
    tags: PropTypes.string,
};
LinkFromSharepointModal.defaultProps = {
    relationId: undefined,
    tags: undefined,
};
export default LinkFromSharepointModal;
